import { AttributeItemInterface } from '@/components/CustomDialog/AddProductAttributesDialog/AddProductAttributesDialog';
import { Attribute } from '@/models/Attribute';
import { ProductVariant } from '@/models/ProductVariant';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<AddProductAttributesOverviewStep>({})
export default class AddProductAttributesOverviewStep extends Vue {
  // #region @Props

  @Prop({ default: () => [] })
  protected attributes!: Attribute[];

  @Prop({ default: () => [] })
  protected selectedAttributes!: AttributeItemInterface[];

  @Prop({ default: () => [] })
  protected selectedProducts!: ProductVariant[];

  @Prop({ default: '1' })
  protected step!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Handlers

  protected onCloseButtonClick(): void {
    this.$emit('close');
  }

  protected onNextButtonClick(): void {
    this.$emit('next');
  }

  protected onPreviousButtonClick(): void {
    this.$emit('previous');
  }

  // #endregion

  // #region Helpers

  protected getSelectedOptions(attribute_id: string) {
    const attributes = this.selectedAttributes.filter((indexedAttribute: AttributeItemInterface) => {
      return indexedAttribute.attribute === attribute_id;
    });

    return attributes.map(attribute => attribute.option);
  }

  protected getAttributeById(attribute_id: string) {
    return this.attributes.find((indexedAttribute: Attribute) => {
      return indexedAttribute.id === attribute_id;
    });
  }

  protected getOptionById(attribute_id: string, option_id: string) {
    const attribute = this.attributes.find((indexedAttribute: Attribute) => {
      return indexedAttribute.id === attribute_id;
    });

    if(attribute && attribute.options) {
      return attribute.options.find((option: Record<string, any>) => {
        return option.id === option_id;
      });

    }

    return {};
  }

  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters

  protected get attributeSummary() {
    const grouped = this.selectedAttributes.filter((attribute, index, self) =>
      index === self.findIndex((indexed) => (
        indexed.attribute === attribute.attribute
      )));

      const test = grouped.map((attribute: AttributeItemInterface) => {
        return {
          attribute: attribute.attribute,
          options: this.getSelectedOptions(`${attribute.attribute}`),
        };
      });
      return test;
  }

  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
